// ------------------------------
// 🔢 CONSTANTES (Datos estáticos)
// ------------------------------
export const page5_items = [
  { text: "Event\nmanagement", color: "green" },
  { text: "Sponsorship\n& commercial\nadvisory", color: "gray" },
  { text: "Sports Tech\n& media", color: "green" },
  { text: "Youth &\nschool sports", color: "gray" },
  { text: "Athlete\nrepresentation\n& advisory", color: "green" },
  { text: "TV & content\nproduction", color: "gray" },
  { text: "Women's sports", color: "green" },
];

export const page7_items = [
  { text: "Crecimiento exponencial del fútbol femenino y deportes emergentes", color: "green" },
  { text: "Auge del sportainment (deporte + entretenimiento)", color: "green" },
  { text: "Expansión en transmisión digital y monetización innovadora", color: "green" },
];
